var $cfcfda392bc6483e$exports = {};
$cfcfda392bc6483e$exports = {
    "collapse": `Zwi\u{144}`,
    "expand": `Rozwi\u{144}`
};


export {$cfcfda392bc6483e$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
